import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzIconModule } from 'ng-zorro-antd';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormErrorModule } from '@app/form-error/module';

import { TosModalComponent } from './tos-modal.component';



const COMPONENTS = [TosModalComponent];
@NgModule({
  imports: [CommonModule,
    NzButtonModule,
    NzCheckboxModule,
    NzModalModule,
    NzFormModule,
    FormsModule,
    NzIconModule,
    ReactiveFormsModule,
    NzUploadModule,
    FormErrorModule],
  declarations: COMPONENTS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: COMPONENTS,
  providers: [],
})
export class TosModalModule { }
